import React, { Component } from 'react';
import '../../css/App.css';
import { observer } from 'mobx-react';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Input from '@material-ui/core/Input';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import appStore from '../../store/AppStore'


const styles = {   
  card:{
    marginTop: "15px",    
  },  
  cardheadertext:{
    fontSize: "18px",
    fontFamily: 'Noto Sans TC, sans-serif'
  },
  cardcontent:{
    paddingTop: "0px",    
  },  
  input:{
    fontFamily: 'Noto Sans TC, sans-serif', 
    color:'#555'   
  },
  attention:{
    fontSize: "12px",
    textAlign: 'justify',
    fontWeight: 300,
    color: '#555'
  }
  

}



class TextInput extends Component { 

  handleChange=(objectKey)=>(e)=>{
      appStore.setTextFieldValue(e.target.value, objectKey);
      
  }

  render() {
    const { classes, title ,objectKey, placeholder, attention } = this.props;
    
    
    return (  
          <React.Fragment>
          <CardHeader
            title={<Typography className={classes.cardheadertext}>{title}</Typography>}           
            className={classes.cardheader}
          />
          <CardContent
            className={classes.cardcontent}
          >            
            <Input
              placeholder={placeholder}
              className={classes.input}              
              onChange={this.handleChange(objectKey)}     
              value={appStore.postData[objectKey]}  
              fullWidth={true}
              inputProps={{
                'aria-label': title,
                'id': objectKey,
                'name': objectKey
              }} 
            />
            {attention?
            <p className={classes.attention}>{attention}</p>:""}
          </CardContent> 
          </React.Fragment>       
        
    );
  }
}

export default withStyles(styles)(observer(TextInput));
